const convertToSeconds = (miliseconds: number): number => {
  return miliseconds / 1000
}

export default convertToSeconds
